import { render } from "./EnbSeoCategorias.vue?vue&type=template&id=31a68c50"
import script from "./EnbSeoCategorias.vue?vue&type=script&lang=js"
export * from "./EnbSeoCategorias.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__